/* Split Ender redesign (Oct 2026): small UI helpers. No dependencies. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Drawer (mobile menu) ---------- */
  var lastFocus = null;
  function openDrawer(d) {
    lastFocus = document.activeElement;
    d.setAttribute('open', '');
    d.removeAttribute('aria-hidden');
    document.body.classList.add('sx-lock');
    var t = d.querySelectorAll('[data-sx-drawer-open]');
    document.querySelectorAll('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = d.querySelector('.sx-drawer__panel button, .sx-drawer__panel a');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawer(d) {
    d.removeAttribute('open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sx-lock');
    document.querySelectorAll('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-sx-drawer-open]');
    if (o) { var d = document.getElementById(o.getAttribute('aria-controls')); if (d) { e.preventDefault(); openDrawer(d); } return; }
    var c = e.target.closest('[data-sx-drawer-close]');
    if (c) { var dd = c.closest('.sx-drawer'); if (dd) { e.preventDefault(); closeDrawer(dd); } }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('.sx-drawer[open]');
    if (d) closeDrawer(d);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var d = document.querySelector('.sx-drawer[open]');
    if (!d) return;
    var f = d.querySelectorAll('.sx-drawer__panel a[href], .sx-drawer__panel button, .sx-drawer__panel input');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Product gallery ---------- */
  if (!customElements.get('sx-gallery')) {
    customElements.define('sx-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.sx-gallery__track');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('.sx-gallery__slide'));
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('.sx-gallery__thumb'));
        this.counter = this.querySelector('[data-sx-count]');
        var self = this, n = this.slides.length;
        this.slides.forEach(function (sl, i) { sl.setAttribute('aria-label', (i + 1) + ' of ' + n); });
        this.thumbs.forEach(function (t, i) { t.setAttribute('aria-label', 'Show photo ' + (i + 1) + ' of ' + n); t.setAttribute('aria-current', i === 0 ? 'true' : 'false'); });
        this.thumbs.forEach(function (t, i) { t.addEventListener('click', function () { self.go(i); }); });
        var prev = this.querySelector('.sx-gallery__nav--prev'), next = this.querySelector('.sx-gallery__nav--next');
        if (prev) prev.addEventListener('click', function () { self.go(Math.max(0, self.index - 1)); });
        if (next) next.addEventListener('click', function () { self.go(Math.min(self.slides.length - 1, self.index + 1)); });
        this.index = 0;
        if (this.track) {
          var raf = null;
          this.track.addEventListener('scroll', function () {
            if (raf) return;
            raf = requestAnimationFrame(function () {
              raf = null;
              var i = Math.round(self.track.scrollLeft / Math.max(1, self.track.clientWidth));
              self.mark(i);
            });
          }, { passive: true });
        }
      }
      go(i, instant) {
        if (!this.slides[i]) return;
        this.track.scrollTo({ left: this.slides[i].offsetLeft - this.track.offsetLeft, behavior: (instant || reduceMotion) ? 'auto' : 'smooth' });
        this.mark(i);
      }
      mark(i) {
        if (i === this.index && this.thumbs[i] && this.thumbs[i].getAttribute('aria-current') === 'true') return;
        this.index = i;
        this.thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (this.counter) this.counter.textContent = (i + 1) + ' / ' + this.slides.length;
        var v = this.slides[i] && this.slides[i].querySelector('video');
        this.slides.forEach(function (s, k) { var vv = s.querySelector('video'); if (vv && k !== i) { try { vv.pause(); } catch (e) {} } });
        if (v && v.dataset.autoplay === 'true' && !reduceMotion) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      }
      /* Called by the theme's VariantSelects.updateMedia() */
      setActiveMedia(mediaId) {
        for (var i = 0; i < this.slides.length; i++) {
          if (this.slides[i].dataset.mediaId === mediaId) { this.go(i); return; }
        }
      }
    });
  }

  /* ---------- Plug notice + sticky add to cart ---------- */
  function plugText(v) {
    var s = (v || '').toLowerCase();
    if (!s || s.indexOf('usa') > -1 || s.indexOf('us ') === 0) return '';
    if (s.indexOf('europ') > -1 || s.indexOf('eu ') > -1) return 'european';
    if (s.indexOf('kingdom') > -1 || s.indexOf('uk') > -1) return 'uk';
    return 'other';
  }
  function initPdp(root) {
    var section = root.getAttribute('data-section');
    var note = root.querySelector('[data-sx-plug-note]');
    var picker = root.querySelector('variant-radios, variant-selects');
    function chargerValue() {
      if (!picker) return '';
      var fs = picker.querySelectorAll('fieldset');
      for (var i = 0; i < fs.length; i++) {
        var name = (fs[i].getAttribute('data-option-name') || '').toLowerCase();
        if (name.indexOf('charg') > -1 || name.indexOf('plug') > -1) {
          var c = fs[i].querySelector('input:checked');
          return c ? c.value : '';
        }
      }
      return null;
    }
    function updateChosen() {
      if (!picker) return;
      picker.querySelectorAll('fieldset').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        var t = fs.querySelector('[data-sx-chosen]');
        if (c && t) t.textContent = c.getAttribute('data-label') || c.value;
      });
    }
    function updateNote() {
      if (!note) return;
      var v = chargerValue();
      var kind = plugText(v);
      var msg = kind && note.getAttribute('data-msg-' + kind);
      if (msg) { note.querySelector('[data-sx-plug-text]').textContent = msg; note.classList.add('is-visible'); }
      else { note.classList.remove('is-visible'); }
    }
    /* sticky bar */
    var sticky = root.querySelector('[data-sx-sticky]');
    var mainBtn = root.querySelector('#ProductSubmitButton-' + section);
    var variants = null;
    try { variants = JSON.parse((picker && picker.querySelector('script[type="application/json"]') || {}).textContent || 'null'); } catch (e) {}
    function currentVariant() {
      var input = root.querySelector('#product-form-' + section + ' input[name="id"]');
      var id = input ? Number(input.value) : 0;
      if (!variants) return null;
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return null;
    }
    /* Buy 1 / Buy 2 offer box: sets the form quantity and keeps the amounts on the chosen variant. */
    var qb = root.querySelector('[data-sx-qb]');
    var qbOff = qb ? (parseInt(qb.getAttribute('data-off'), 10) || 0) : 0;
    var qbPrices = {};
    if (qb) { try { qbPrices = JSON.parse(qb.querySelector('script[type="application/json"]').textContent); } catch (e) {} }
    var qbForm = root.querySelector('#product-form-' + section);
    function usd(cents) { return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    function qbQty() { var r = qb && qb.querySelector('input[type="radio"]:checked'); return r && r.value === '2' ? 2 : 1; }
    function qbPrice() { var i = qbForm && qbForm.querySelector('input[name="id"]'); return i && qbPrices[i.value] != null ? qbPrices[i.value] : null; }
    function qbText(name, text) { Array.prototype.forEach.call(qb.querySelectorAll('[data-qb="' + name + '"]'), function (el) { el.textContent = text; }); }
    function updateOffer() {
      if (!qb) return;
      var qty = qbQty(), price = qbPrice();
      Array.prototype.forEach.call(qb.querySelectorAll('.sx-qb__card'), function (c) {
        var r = c.querySelector('input[type="radio"]');
        c.classList.toggle('is-on', !!(r && r.checked));
      });
      var q = qbForm && qbForm.querySelector('input[name="quantity"]');
      if (q) q.value = qty;
      if (price != null) {
        qbText('one', usd(price));
        qbText('each2', usd(price - qbOff));
        qbText('two', usd((price - qbOff) * 2));
        qbText('was', usd(price * 2));
      }
      var label = mainBtn && mainBtn.querySelector('span');
      if (label && !mainBtn.hasAttribute('disabled')) {
        label.textContent = qty === 2 && price != null ? 'Add 2 to cart · ' + usd((price - qbOff) * 2) : (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
      }
      updateSticky();
    }
    function money(cents) {
      var fmt = (window.cartStrings && window.cartStrings.moneyFormat) || '${{amount}}';
      var amt = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amt).replace(/<[^>]+>/g, '');
    }
    function updateSticky() {
      if (!sticky) return;
      var v = currentVariant();
      var p = sticky.querySelector('[data-sx-sticky-price]');
      var t = sticky.querySelector('[data-sx-sticky-variant]');
      var q2 = !!qb && qbQty() === 2;
      var slash = sticky.querySelector('.sx-slash');
      if (slash) slash.hidden = q2;
      if (p && !p.getAttribute('data-one')) p.setAttribute('data-one', p.textContent);
      if (p && q2 && qbPrice() != null) p.textContent = usd((qbPrice() - qbOff) * 2);
      else if (v && p) p.textContent = money(v.price);
      else if (p) p.textContent = p.getAttribute('data-one');
      if (v && t) {
        var labels = picker ? Array.prototype.map.call(picker.querySelectorAll('input:checked'), function (i) { return i.getAttribute('data-label') || i.value; }) : [];
        t.textContent = labels.length ? labels.join(' · ') : (v.title === 'Default Title' ? '' : v.title.replace(/\s*\/\s*/g, ' · '));
      }
      var b = sticky.querySelector('button');
      if (b && mainBtn) { b.disabled = mainBtn.hasAttribute('disabled'); b.querySelector('span').textContent = mainBtn.hasAttribute('disabled') ? (mainBtn.textContent.trim() || 'Unavailable') : (q2 ? 'Add 2 to cart' : (b.getAttribute('data-label') || 'Add to cart')); }
    }
    if (sticky && mainBtn) {
      var footer = document.querySelector('.sx-footer');
      var ticking = false;
      function place() {
        ticking = false;
        var past = mainBtn.getBoundingClientRect().bottom < 0;
        var footIn = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        var show = past && !footIn;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = sticky.querySelector('button');
        if (b) b.tabIndex = show ? 0 : -1;
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(place); } }, { passive: true });
      window.addEventListener('resize', place);
      place();
      sticky.querySelector('button').addEventListener('click', function () {
        if (mainBtn.hasAttribute('disabled')) { mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        mainBtn.click();
      });
    }
    if (picker) {
      picker.addEventListener('change', function () { setTimeout(function () { updateChosen(); updateNote(); updateSticky(); updateOffer(); }, 0); });
    }
    /* US shoppers start on the USA plug, even when a link (e.g. a Google Shopping ad) opens a UK/EU plug.
       Shoppers outside the US, and anyone who picked a plug themselves this visit, keep their choice. */
    function isPlugSet(fs) {
      var name = (fs.getAttribute('data-option-name') || '').toLowerCase();
      return name.indexOf('charg') > -1 || name.indexOf('plug') > -1 || name.indexOf('cord') > -1;
    }
    function isUsValue(v) { return /\bus(a)?\b/i.test(v || ''); }
    if (picker) {
      var plugKey = 'sx-plug-picked:' + (picker.getAttribute('data-url') || location.pathname);
      picker.addEventListener('change', function (e) {
        if (!e.isTrusted) return;
        var fs = e.target.closest && e.target.closest('fieldset');
        if (fs && isPlugSet(fs)) { try { sessionStorage.setItem(plugKey, '1'); } catch (err) {} }
      });
      var country = (window.Shopify && window.Shopify.country) || 'US';
      var picked = false;
      try { picked = !!sessionStorage.getItem(plugKey); } catch (err) {}
      if (['US', 'PR', 'VI', 'GU', 'AS', 'MP', 'UM'].indexOf(country) > -1 && !picked) {
        var toUs = function () {
          picker.querySelectorAll('fieldset').forEach(function (fs) {
            if (!isPlugSet(fs)) return;
            var radios = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]'));
            var checked = radios.filter(function (i) { return i.checked; })[0];
            if (!checked || isUsValue(checked.value)) return;
            var us = radios.filter(function (i) { return isUsValue(i.value) && !i.classList.contains('disabled'); })[0];
            if (!us) return;
            us.checked = true;
            try { us.dispatchEvent(new Event('change', { bubbles: true })); } catch (err) {}
            /* The cart must get the plug that is shown: if the theme did not take the switch, go back. */
            var idInput = root.querySelector('#product-form-' + section + ' input[name="id"]');
            if (!picker.currentVariant || !idInput || String(picker.currentVariant.id) !== String(idInput.value)) {
              checked.checked = true;
              updateChosen(); updateNote(); updateSticky();
            }
          });
        };
        /* Wait for the theme's variant and product-form elements, or the switch is ignored. */
        if (window.customElements && customElements.whenDefined) {
          var waits = [customElements.whenDefined(picker.localName)];
          if (root.querySelector('product-form')) waits.push(customElements.whenDefined('product-form'));
          Promise.all(waits).then(function () { setTimeout(toUs, 0); });
        }
      }
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { updateSticky(); updateOffer(); }, 30); });
    }
    if (qb) qb.addEventListener('change', updateOffer);
    updateChosen(); updateNote(); updateSticky(); updateOffer();
    window.addEventListener('pageshow', function () { updateChosen(); updateNote(); updateSticky(); updateOffer(); });
  }
  /* ---------- App promo bar spacer (qikify Salekit bar is absolute at top:0) ---------- */
  function appBar() {
    var sp = document.querySelector('[data-sx-appbar]');
    if (!sp) return;
    function bar() {
      var b = document.querySelector('.qsk-promobar__single-bar');
      return b && b.offsetHeight > 0 && getComputedStyle(b).display !== 'none' ? b : null;
    }
    var ann = document.querySelector('.sx-announce');
    function setOffset() {
      var h = sp.offsetHeight + (ann ? ann.offsetHeight : 0);
      document.documentElement.style.setProperty('--sx-head-offset', h + 'px');
    }
    function sync(final) {
      var b = bar();
      if (b) sp.style.height = b.offsetHeight + 'px';
      else if (final) sp.style.height = '0px';
      setOffset();
    }
    setOffset();
    var tries = 0;
    var t = setInterval(function () { tries++; sync(tries > 16); if (bar() || tries > 16) clearInterval(t); }, 250);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.qsk-promobar')) setTimeout(function () { sync(true); }, 350);
    });
    window.addEventListener('resize', function () { sync(false); });
  }
  /* Desktop nav dropdowns: close on outside click / Escape, one open at a time */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.sx-nav__dd[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.sx-nav__dd[open]').forEach(function (d) { d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) s.focus(); });
  });
  /* Delivery-estimate app widget: show it under the buy buttons instead of between price and options */
  function placeDelivery(root) {
    var buy = root.querySelector('.sx-pdp__buy');
    if (!buy || !('MutationObserver' in window)) return;
    function move() {
      var w = root.querySelector('.sx-pdp__installments .delivery-widget__auto');
      if (w) buy.insertAdjacentElement('afterend', w);
    }
    move();
    var mo = new MutationObserver(move);
    mo.observe(root, { childList: true, subtree: true });
  }
  /* Looping clips get a visible pause / play button (WCAG 2.2.2) */
  function videoControls() {
    document.querySelectorAll('.sx-clip video, .sx-split__media video, .sx-step__media video').forEach(function (v) {
      var box = v.parentElement;
      if (!box || box.querySelector('.sx-vbtn')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sx-vbtn';
      function label() { var paused = v.paused || v.dataset.sxPaused === '1'; b.setAttribute('aria-label', paused ? 'Play video' : 'Pause video'); b.innerHTML = paused ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M8 5.5v13l11-6.5z"/></svg>' : '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg>'; }
      b.addEventListener('click', function () {
        if (v.paused) { v.dataset.sxPaused = ''; if (!v.src && v.getAttribute('data-gif-src')) { v.src = v.getAttribute('data-gif-src'); v.removeAttribute('data-gif-src'); } var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.dataset.sxPaused = '1'; v.pause(); }
        label();
      });
      v.addEventListener('play', label); v.addEventListener('pause', label);
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      box.appendChild(b); label();
    });
  }
  function boot() {
    if (reduceMotion) document.querySelectorAll('.sx-video iframe[src*="autoplay=1"]').forEach(function (f) { f.src = f.src.replace('autoplay=1', 'autoplay=0'); });
    videoControls();
    document.querySelectorAll('[data-sx-pdp]').forEach(initPdp);
    document.querySelectorAll('[data-sx-pdp]').forEach(placeDelivery);
    appBar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
